<vw-toast-popup [isOpen]="isOpen" [title]="'garden.harvest.title' | translate"
  [subtitle]="plant?.cultivationVariant?.name | Label" (close)="onClose()">
  <div class="flex flex-col gap-4 px-4 pb-6">
    <p class="text-body-s text-vw-muted">{{ 'garden.harvest.subtitle' | translate }}</p>

    <div class="flex flex-col gap-1">
      <p class="text-body-s font-semibold text-vw-body">{{ 'garden.harvest.date-label' | translate }}</p>
      <vw-date-picker [initialValue]="date" [showInput]="true" [showDatepicker]="false" (dateSelected)="onDateChange($event)" class="w-full"></vw-date-picker>
    </div>

    <div class="flex flex-col gap-1">
      <p class="text-body-s font-semibold text-vw-body">{{ 'garden.harvest.quantity-label' | translate }}</p>
      <input
        type="number"
        min="0"
        inputmode="decimal"
        [(ngModel)]="quantity"
        class="min-h-btn w-full rounded-field border border-vw-line-strong bg-vw-surface px-3 text-body text-vw-ink outline-none focus:border-vw-primary"
        placeholder="0"
      />
    </div>

    <!-- Unité : sélecteur en ligne scrollable (un tap, pas d'ouverture de dropdown),
         dessiné comme les pastilles de choix de l'app ; un second tap retire l'unité. -->
    <div class="flex flex-col gap-1">
      <p class="text-body-s font-semibold text-vw-body">{{ 'garden.harvest.unit-label' | translate }}</p>
      <div class="unit-wheel -mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
        @for (u of unitOptions; track u.value) {
          <button
            type="button"
            (click)="selectUnit(u.value)"
            [attr.aria-pressed]="selectedUnit === u.value"
            class="min-h-target shrink-0 rounded-pill border px-4 text-body-s font-medium transition-colors"
            [ngClass]="selectedUnit === u.value ? 'border-vw-primary bg-vw-primary text-vw-on-color' : 'border-vw-line bg-vw-surface text-vw-muted active:bg-vw-surface-sunk'"
          >
            {{ u.label }}
          </button>
        }
      </div>
    </div>

    <div class="flex flex-col gap-1">
      <p class="text-body-s font-semibold text-vw-body">{{ 'garden.harvest.note-label' | translate }}</p>
      <input
        type="text"
        maxlength="500"
        [(ngModel)]="note"
        class="min-h-btn w-full rounded-field border border-vw-line-strong bg-vw-surface px-3 text-body text-vw-ink outline-none focus:border-vw-primary"
        [placeholder]="'garden.harvest.note-placeholder' | translate"
      />
    </div>

    @if (submitFailed) {
      <p role="alert" class="text-body-s text-vw-danger" data-testid="harvest-error">{{ 'errors.businessException' | translate }}</p>
    }
    <!-- Bouton principal en bas, pleine largeur, comme les feuilles récentes. -->
    <vw-button
      (click)="submit()"
      label="garden.harvest.confirm"
      look="primary"
      customClass="w-full"
      [loading]="submitLoading"
    >
    </vw-button>
  </div>
</vw-toast-popup>
